import { all, call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import watchVotings from '../domains/Votings/sagas/watchers';
import watchVoting from '../domains/Voting/sagas/watchers';

export default function* rootSaga(): SagaIterator<void> {
  yield all([call(watchVotings), call(watchVoting)]);
}
